export default "__VITE_ASSET__DeAhCNBW__"